import { styled, TableCell } from '@mui/material';

export const CustomTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

export default CustomTableCell;
